import * as React from "react"

import { TagsBlock } from "@components"
import { LIMITS_VIEWS } from "../@constants"
import { ChipBlock, CommonIconButton } from "../../@components"


export default function brandColumn() {
	return [{
		name: "filterBrands", label: 'Brands',
		options: {
            display: 'excluded',
            customBodyRowRender: (_, row) => {

                if (Array.isArray(row.brands) && row.brands.length > 0) {
                    const names = row.brands.map(brand => brand.name)
                    return <TagsBlock list={names} />
                }
                return 'Empty'
            }
        }
	}, {
		name: "brands", label: 'Brands',
        options: {
            filter: false,
            setCellProps: () => ({ sx: { textAlign: "center", maxWidth: 200 } }),
            customBodyRowRenderLite: (value, row) => {

                const brandsToShow = Array.isArray(value) 
                    ? value.slice(0, LIMITS_VIEWS.BRANDS).map((brand) => brand.name) 
                    : []

                return <>
                    <ChipBlock listElements={brandsToShow} />
                    {Array.isArray(value) && value.length > LIMITS_VIEWS.BRANDS && <CommonIconButton alertSelected={row} />}
                </>
            }
        }
	}]
}